import {
    Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import AbstractScoringSection from './sections/AbstractScoringSection';

const AbstractScoreEdit = () => {
    const { id } = useParams();
    const [data, setData] = useState();

    const getData = async () => {
        await axiosInstance
            .get('api/prv/submissions/' + id)
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            {data && (
                <Box pt={2} pb={4}>
                    <AbstractScoringSection data={data} />
                </Box>
            )}
        </>
    );
};

export default AbstractScoreEdit;
